import type { IData } from '../model/IData'
import type { IPerson } from '../model/IPerson'
import { Relationship } from '../model/Relationship'
import { expectDefined } from './expectDefined'
import { getChildren } from './getChildren'
import { getParentCouple } from './getParentCouple'
import { getSpouses } from './getSpouses'

export function markRelationship(data: IData) {
	for (const person of Object.values(data.personsById)) {
		markPerson(data, person)
	}
}

function markPerson(
	data: IData,
	person: IPerson,
	fallback = Relationship.Related,
) {
	if (person.lastName?.includes('Parditka')) {
		if (person.relationship == null) {
			person.relationship = Relationship.Parditka
			markAncestors(data, person, true)
			markSpouses(data, person)
			markDescendants(data, person, true)
		}
	} else if (person.relationship == null || fallback < person.relationship) {
		person.relationship = fallback
	}
}

function markAncestors(data: IData, person: IPerson, isParent?: boolean) {
	const parentCouple = getParentCouple(data, person.id)
	if (parentCouple) {
		if (parentCouple.maleId) {
			const father = expectDefined(data.personsById[parentCouple.maleId])
			markPerson(
				data,
				father,
				isParent ? Relationship.Parent : Relationship.Ancestor,
			)
			markAncestors(data, father)
		}
		if (parentCouple.femaleId) {
			const mother = expectDefined(data.personsById[parentCouple.femaleId])
			markPerson(
				data,
				mother,
				isParent ? Relationship.Parent : Relationship.Ancestor,
			)
			markAncestors(data, mother)
		}
	}
}

function markSpouses(data: IData, person: IPerson) {
	for (const spouse of getSpouses(data, person.id)) {
		markPerson(data, spouse, Relationship.Spouse)
	}
}

function markDescendants(data: IData, person: IPerson, isChild?: boolean) {
	for (const child of getChildren(data, person.id)) {
		markPerson(
			data,
			child,
			isChild ? Relationship.Child : Relationship.Descendant,
		)
		markDescendants(data, child)
	}
}
